import { z } from 'zod';
/** Exec demo-data slice — the entities the Execute-mode screens read (SDD §7.4: signals, copy providers, quotes, filter vocabularies).
 *  Transcribed from the design reference `exec()` (script lines 406–812). Every field is deterministic, seeded and labeled simulated. */

/** AI signal: [symbol, direction LONG/SHORT, confidence %, entry, stop loss, take profit, R:R label, rationale] */
export const SignalRowSchema = z.tuple([
  z.string(), // sym
  z.string(), // dir LONG/SHORT
  z.number(), // conf %
  z.string(), // entry (display)
  z.string(), // sl (display)
  z.string(), // tp (display)
  z.string(), // rr label
  z.string(), // note
]);
export const ProviderRiskSchema = z.enum(['Conservative', 'Moderate', 'Aggressive']);
/** Copy-trading provider: [id, name, style, return %, drawdown %, followers, risk profile, win rate %, profit factor, strategies] */
export const ProviderRowSchema = z.tuple([
  z.string(), // id
  z.string(), // name
  z.string(), // style
  z.number(), // ret %
  z.number(), // dd %
  z.number(), // followers
  ProviderRiskSchema, // risk
  z.number(), // wr %
  z.number(), // pf
  z.array(z.string()), // strats
]);
/** Order-desk quote row: [symbol, bid, ask, spread] — all display strings. The XAUUSD row is derived from the live chart at runtime. */
export const QuoteRowSchema = z.tuple([z.string(), z.string(), z.string(), z.string()]);

export const ExecDataSchema = z
  .object({
    signals: z.array(SignalRowSchema),
    providers: z.array(ProviderRowSchema),
    quotes: z.array(QuoteRowSchema),
    /** Trades-screen strategy filter vocabulary (menu items after "All strategies"). */
    tradeStrategies: z.array(z.string()),
    /** Trades-screen account filter vocabulary (menu items after "All accounts"). */
    tradeAccounts: z.array(z.string()),
    /** Copy-trading strategy filter list (settings tab). */
    copyStrategies: z.array(z.string()),
  })
  .strict();
export type ExecData = z.infer<typeof ExecDataSchema>;
export type SignalRow = z.infer<typeof SignalRowSchema>;
export type ProviderRow = z.infer<typeof ProviderRowSchema>;
export type ProviderRisk = z.infer<typeof ProviderRiskSchema>;
export type QuoteRow = z.infer<typeof QuoteRowSchema>;
